import { render, staticRenderFns } from "./NeedARideSubstep.vue?vue&type=template&id=bcea841e"
import script from "./NeedARideSubstep.vue?vue&type=script&lang=js"
export * from "./NeedARideSubstep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports